const fnolGetters = {
    getFullPageLoadingCount: (state: any) => {
        return state.popup.fullPageLoadingCount
    }
}

export default fnolGetters
